import {useUnlockChoiceCta} from "../../auth/hooks/use_unlock_choice_cta";
import {useGetOfferConstructionGalleryQuery} from "../api/get_offer_construction_gallery";
import {hasOffer3dView, Offer3dViewIdSource} from "../utils/has_offer_3d_view";

type ConstructionPhotosOffer = NonNullable<Offer3dViewIdSource> & {id: number};

export const useConstructionPhotosUnlockChoice = (offer: ConstructionPhotosOffer) => {
    const {data: constructionGalleryResponse} = useGetOfferConstructionGalleryQuery(offer.id);
    const {startUnlockChoice} = useUnlockChoiceCta();

    const hasContent = Boolean(constructionGalleryResponse?.gallery?.length) || hasOffer3dView(offer, constructionGalleryResponse?.construction_3d_tours);

    return {
        hasContent,
        startConstructionPhotosUnlockChoice: () => startUnlockChoice({kind: "construction_photos", hasContent})
    };
};
import {useUnlockChoiceCta} from "../../auth/hooks/use_unlock_choice_cta";
import {useGetOfferConstructionGalleryQuery} from "../api/get_offer_construction_gallery";
import {hasOffer3dView, Offer3dViewIdSource} from "../utils/has_offer_3d_view";

type ConstructionPhotosOffer = NonNullable<Offer3dViewIdSource> & {id: number};

export const useConstructionPhotosUnlockChoice = (offer: ConstructionPhotosOffer) => {
    const {data: constructionGalleryResponse} = useGetOfferConstructionGalleryQuery(offer.id);
    const {startUnlockChoice} = useUnlockChoiceCta();

    const hasContent = Boolean(constructionGalleryResponse?.gallery?.length) || hasOffer3dView(offer, constructionGalleryResponse?.construction_3d_tours);

    return {
        hasContent,
        startConstructionPhotosUnlockChoice: () => startUnlockChoice({kind: "construction_photos", hasContent})
    };
};
